import { render, staticRenderFns } from "./PhotoUploader.vue?vue&type=template&id=78412856"
import script from "./PhotoUploader.vue?vue&type=script&lang=ts"
export * from "./PhotoUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports